module.exports = __webpack_public_path__ + "media/images/icon_list/answer-380fadad362e88af666a09fd68c1721a.svg";